export default "__VITE_ASSET__XDB_OxRb__"